
$(document).ready(function () {
  $(document).on("change", '#richiediFattura', function () {
    var checkbox = document.getElementById("richiediFattura");
    var campoPIVA = document.getElementById("campoPIVA");
    var campoSDI = document.getElementById("campoSDI");
    var campoPEC = document.getElementById("campoPEC");
    var partitaIVA = document.getElementById("partitaIVA");
    var codiceSDI = document.getElementById("codiceSDI");
    var codicePEC = document.getElementById("codicePEC");
    partitaIVA.value = "";
    codiceSDI.value = "";
    codicePEC.value = "";

    if (this.checked) {
      campoPIVA.style.display = "block";
      partitaIVA.setAttribute("required", "required");

      campoSDI.style.display = "block";
      codiceSDI.setAttribute("required", "required");

      campoPEC.style.display = "block";
      codicePEC.setAttribute("required", "required");
    } else {
      campoPIVA.style.display = "none";
      partitaIVA.removeAttribute("required");

      campoSDI.style.display = "none";
      codiceSDI.removeAttribute("required");

      campoPEC.style.display = "none";
      codicePEC.removeAttribute("required");
    }
  }).trigger('change');



});